import React from "react";
import "./style/SignInScreen.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FInput from "../../components/FInput/FInput";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import { useSignInScreen } from "./hooks/useSignInScreen";
import FInputt from "../../components/FInputt/FInputt";
import { ArrowLeftIcon } from "@heroicons/react/solid";

const SignInScreen = ({ param }) => {
  const { formik, parameters, route } = useSignInScreen();

  return (
    <>
      <div className="sm:border-0 sm:border-red-600 sm:h-screen sm:relative sm:grid sm:place-items-center">
        <div className="w-screen border-0 h-[22rem] sm:w-[670px] md:w-[770px] sm:shadow-2xl sm:absolute border-red-600 grid grid-rows-6 sm:grid-rows-1 grid-cols-1 sm:grid-cols-12">
          <div
            className="absolute pt-10 sm:pt-6 pl-5 sm:pl-5 z-50 cursor-pointer"
            onClick={() => {
              route("/");
            }}
          >
            <div className="w-11 h-11 bg-white rounded-full grid place-items-center">
              <ArrowLeftIcon className="w-6" />
            </div>
          </div>
          <img
            src={require("../../components/assets/images/3-h.png")}
            className="border-0 hidden sm:block border-red-600 w-full h-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />
          <img
            src={require("../../components/assets/images/3-v.png")}
            className="border-0 sm:hidden block border-red-600 w-full gap-0 row-span-3 sm:grid-rows-1 col-span-7"
          />

          <div className="border-0 absolute sm:pl-[50%] md:pl-[50%]  pt-[45%] sm:pt-0 border-blue-600 w-full sm:h-[100%] row-span-3 sm:grid-rows-1 col-span-5 sm:grid sm:items-center">
            <form
              onSubmit={formik.handleSubmit}
              className="text-center px-7 sm:px-6 md:px-10"
            >
              <div className="text-[20px] font-bold">Bienvenido de nuevo</div>
              <div className="pt-10 ml-3 text-large font-medium pb-4">
                <FiconPhoneNumber
                  sizeIcon="24px"
                  phoneNumber={parameters.state.phoneNumber}
                />
              </div>
              <div className="mt-8">
                <FInputt
                  type="password"
                  name="password"
                  title="Contraseña"
                  placeholder="Ingresa tu contraseña"
                  formik={formik}
                  onChange={(e) => {
                    formik.setFieldValue("password", e);
                  }}
                />
              </div>
              <div
                className="text-sm pb-4 mt-2 mr-4 font-semibold text-[16px] text-Secondary cursor-pointer text-right"
                onClick={() => {
                  route("/RecoverPassword", {
                    state: {
                      phoneNumber: parameters.state.phoneNumber,
                    },
                  });
                }}
              >
                ¿Olvidaste tu contraseña?
              </div>
              <div className="mx-3 pb-12 sm:pb-0">
                <FInputt type="submit" title="Continuar" formik={formik} />
              </div>
              <div
                className="text-sm pb-4 mt-4 font-semibold text-[16px] text-Secondary cursor-pointer"
                onClick={() => {
                  route("/");
                }}
              >
                Entrar con otra cuenta
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignInScreen;
